import { Switch } from '@headlessui/react';

import { cn } from '@/lib/utils';

interface BadgeSwitchProps {
	label: string;
	checked: boolean;
	onChange: () => void;

	subLabel?: string;
	disabled?: boolean;
	className?: string;
}

function BadgeSwitch({
	label,
	subLabel,
	checked,
	onChange,
	disabled,
	className,
}: BadgeSwitchProps) {
	return (
		<Switch
			checked={checked}
			onChange={onChange}
			disabled={disabled}
			className={cn(
				'flex shrink-0 items-center gap-1.5 rounded-md border border-gray-200 bg-gray-50 px-2.5 py-1.5 font-medium text-gray-600 text-xs transition-colors data-disabled:cursor-not-allowed data-checked:border-gray-300 data-checked:bg-white data-checked:text-gray-900 data-disabled:opacity-50 sm:gap-2 sm:px-3 sm:py-2 sm:text-sm',
				className,
			)}
		>
			{checked && (
				<span className="relative inline-flex size-3.5 items-center justify-center rounded-full bg-green-500 sm:size-4">
					<svg
						className="size-2.5 text-white sm:size-3"
						viewBox="0 0 12 12"
						fill="none"
						aria-hidden="true"
					>
						<path
							d="M10 3L4.5 8.5L2 6"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</span>
			)}
			{label}
			{subLabel && <span className="text-xs opacity-60 sm:text-xs">{subLabel}</span>}
		</Switch>
	);
}
export { BadgeSwitch };
